import "array.prototype.at/auto";
import { Buffer as BufferPolyfill } from "buffer";
declare let _Buffer: typeof BufferPolyfill;
globalThis.Buffer = BufferPolyfill;
